export default "__VITE_ASSET__7d5be2b2__"